module.exports = __webpack_public_path__ + "ui-static/img/external-detectors-no-items_light.d8b618df.svg";